import { Injectable } from "@angular/core";
import { AbstractControl } from "@angular/forms";
import { Observable, Observer, of } from "rxjs";
import { PlaceDto } from "./authentication/connection/interfaces/apiInterfaces";
import { from } from 'rxjs';

declare var require: any;

interface IRouteResponse {
  totalDistance: number;
}

@Injectable()
export class GooglePlacesService {
  constructor() {}

  // private _autocompleteService: google.maps.places.AutocompleteService;

  // get autocompleteService(): google.maps.places.AutocompleteService {
  //   return (
  //     this._autocompleteService || new google.maps.places.AutocompleteService()
  //   );
  // }

  getUTCOffsetByPlaceLatLng(lat: number, lon: number): Observable<number> {
    const moment = require('moment-timezone');
    const ts = require('@mapbox/timespace');
    const ct = require('countries-and-timezones');
    let siny = Math.sin((lat * Math.PI) / 180);
    let TILE_SIZE = 256;
    
    // Truncating to 0.9999 effectively limits latitude to 89.189. This is
    // about a third of a tile past the edge of the world tile.
    siny = Math.min(Math.max(siny, -0.9999), 0.9999);

    let tile = [
      Math.floor(TILE_SIZE * (0.5 + lon / 360)),
      Math.floor(
        TILE_SIZE * (0.5 - Math.log((1 + siny) / (1 - siny)) / (4 * Math.PI))
      ),
      8,
    ];
    let timezone1 = ts.getFuzzyTimezoneFromTile(tile);
    let isDst = moment().tz(ct.getTimezone(timezone1).name).isDST();
    return isDst ? of(ct.getTimezone(timezone1).dstOffset) : of(ct.getTimezone(timezone1).utcOffset);
  }

  getUTCOffsetByTimezoneName(timezoneName: string): Observable<number> {
    const ct = require('countries-and-timezones');
    return of(ct.getTimezone(timezoneName).utcOffset);
  }

  public getTimezoneOffset(offset: number): string {
    offset = offset / 60;
    let sign = offset >= 0 ? '+' : '-';
    let minutes =
      '00' +
      (((Math.abs(offset) - Math.floor(offset)) * 60) % 60)
        .toFixed(2)
        .toString();
    minutes = minutes.substr(minutes.length - 2);
    let hours = '00' + Math.floor(Math.abs(offset)).toString();
    hours = hours.substr(hours.length - 2);

    return sign + hours + minutes;
  }

  // /**
  //  * Get places predictions by autocomplete string.
  //  *
  //  * Wraps the Google Maps API places autocomplete service into an observable.
  //  *
  //  * @param request google.maps.places.AutocompletionRequest
  //  * @return An observable of google.maps.places.AutocompletePrediction
  //  */
  // getPlacePredictions(
  //   request: google.maps.places.AutocompletionRequest
  // ): Observable<google.maps.places.AutocompletePrediction[]> {
  //   return Observable.create(
  //     (observer: Observer<google.maps.places.AutocompletePrediction[]>) => {
  //       // Invokes getPlacePredictions method of Google Maps API places.
  //       this.autocompleteService.getPlacePredictions(
  //         request,
  //         (
  //           results: google.maps.places.AutocompletePrediction[],
  //           status: google.maps.places.PlacesServiceStatus
  //         ) => {
  //           if (status === google.maps.places.PlacesServiceStatus.OK) {
  //             observer.next(results);
  //             observer.complete();
  //           } else if (google.maps.places.PlacesServiceStatus.ZERO_RESULTS) {
  //             observer.complete();
  //           } else {
  //             console.log(
  //               'Places service: places predictions failed due to: ' + status
  //             );
  //             observer.error(status);
  //           }
  //         }
  //       );
  //     }
  //   );
  // }

  // /**
  //  * Gets the stops for waypoints
  //  * @param waypointsList list of waypoints
  //  * @param markersArray  marker array to mark stops
  //  * @param map           map to draw markers
  //  * @param icon          icon for stops
  //  */
  // public getStopsWaypoints(
  //   waypointsList: any[],
  //   markersArray: google.maps.Marker[],
  //   map: any,
  //   icon: any
  // ): google.maps.DirectionsWaypoint[] {
  //   if (!waypointsList) {
  //     return null;
  //   }
  //   let waypoints: google.maps.DirectionsWaypoint[] = [];
  //   if (markersArray != null) {
  //     this.clearMarkers(markersArray);
  //   }
  //   waypointsList.forEach((stop: any, index: number) => {
  //     let location = this.getLatLngFromPlaceDto(stop);
  //     if (index < waypointsList.length && location) {
  //       let waypoint: google.maps.DirectionsWaypoint = {
  //         location: location,
  //         stopover: true,
  //       };
  //       waypoints.push(waypoint);
  //       markersArray.push(
  //         new google.maps.Marker({
  //           position: location,
  //           map: map,
  //           icon: icon,
  //         })
  //       );
  //     }
  //   });

  //   return waypoints;
  // }

  // /**
  //  * Draws a polyline given a route
  //  * @param map     map to draw polyline on
  //  * @param coords  route
  //  */
  // public drawPolyline(
  //   map: google.maps.Map,
  //   coords: google.maps.LatLng[]
  // ): google.maps.Polyline {
  //   let polyline = new google.maps.Polyline({
  //     map: map,
  //     path: coords,
  //     clickable: false,
  //     strokeColor: '#0088FF',
  //     strokeWeight: 6,
  //     strokeOpacity: 0.6,
  //   });

  //   polyline.setMap(map);
  //   return polyline;
  // }

  // /**
  //  * maps the value of a control to latlng
  //  * @param control control to map value from
  //  */
  // public getLatLngFromControl(control: AbstractControl): google.maps.LatLng {
  //   if (control.value && control.value.latitude && control.value.longitude) {
  //     const latLng = new google.maps.LatLng(
  //       control.value.latitude,
  //       control.value.longitude
  //     );
  //     return latLng;
  //   } else {
  //     return null;
  //   }
  // }

  // /**
  //  * Clears an array of markers
  //  * @param markersArray
  //  */
  // public clearMarkers(markersArray: google.maps.Marker[]) {
  //   markersArray.forEach((marker) => {
  //     if (marker) {
  //       marker.setMap(null);
  //       marker = null;
  //     }
  //   });
  //   markersArray = [];
  // }

  // /**
  //  * Maps a LatLng to a PlaceDTO interface
  //  * @param value
  //  */
  // public toPlaceDTO(value: any): PlaceDto {
  //   if (value && value.latitude && value.longitude) {
  //     return {
  //       longitude: value.longitude,
  //       latitude: value.latitude,
  //       placeId: value.placeId ? value.placeId : value.mapPlaceId,
  //       shortName: value.shortName,
  //       waitTime: value.waitTime ? value.waitTime : null,
  //     };
  //   }
  //   return null;
  // }

  // /**
  //  * Maps a PlaceDTO into a google.maps.LatLng
  //  * @param value   PlaceDTO to map
  //  */
  // public getLatLngFromPlaceDto(value: PlaceDto) {
  //   return new google.maps.LatLng(
  //     Number(value.latitude),
  //     Number(value.longitude)
  //   );
  // }

  // /**
  //  * Icons collection
  //  * @param type  icon type
  //  */
  // public getIcon(type: number): any {
  //   let image = { url: '' };
  //   let imagesCollection = [
  //     'assets/img/icon-origin2.png',
  //     'assets/img/icon-origin.png',
  //     'assets/img/icon-destination.png',
  //     'assets/img/icons/icono-stop.png',
  //   ];
  //   return (image.url = imagesCollection[type].toString());
  // }

  // /**
  //  * Draws a marker given a position, in a given google maps instance, with an optional icon
  //  * @param position  position of the marker (in LatLng)
  //  * @param map       map instance to draw the marker
  //  * @param marker    instance of the marker (in case it's beign reused)
  //  * @param icon      icon for the marker
  //  */
  // public drawMarker(
  //   position: google.maps.LatLng,
  //   map: google.maps.Map,
  //   marker?: google.maps.Marker,
  //   icon?: any
  // ): google.maps.Marker {
  //   if (marker) {
  //     marker.setMap(null);
  //     marker = null;
  //   }
  //   marker = new google.maps.Marker({
  //     position: position,
  //     map: map,
  //     icon: icon,
  //   });
  //   return marker;
  // }

  // /**
  //  * use route(), which returns an interface with the route info
  //  * Calculates and displays a route using a given directions renderer instance.
  //  * Works with multiple destinations and options like 'Avoid tolls/highways'
  //  * @param directionsRenderer  directions renderer instance
  //  * @param origin              origin LatLng of the route
  //  * @param destination         destination LatLng of the route
  //  * @param waypoints           waypoints of the route (optionals)
  //  * @param options             options for the route
  //  */
  // public calculateAndDisplayRoute(
  //   directionsRenderer: google.maps.DirectionsRenderer,
  //   origin: google.maps.LatLng,
  //   destination: google.maps.LatLng,
  //   waypoints?: google.maps.DirectionsWaypoint[],
  //   options?: any
  // ): Observable<google.maps.DirectionsResult | null> {
  //   return from(
  //     new Promise<google.maps.DirectionsResult | null>((resolve) => {
  //       let directionsService = new google.maps.DirectionsService();
  //       directionsService.route(
  //         {
  //           origin: origin,
  //           waypoints: waypoints,
  //           destination: destination,
  //           travelMode: google.maps.TravelMode.DRIVING,
  //           avoidTolls: options != null ? options.avoidTolls : null,
  //           avoidHighways: options != null ? options.avoidHighways : null,
  //           unitSystem: google.maps.UnitSystem.METRIC,
  //           provideRouteAlternatives: true,
  //         },
  //         (response, status) => {
  //           if (status === google.maps.DirectionsStatus.OK && response) {
  //             // Seleccionar la ruta más rápida o la más corta según la opción proporcionada
  //             response.routes = options?.fastestRoute
  //               ? [this.getFastestRoute(response)]
  //               : [this.getShortestRoute(response)];
  
  //             // Configurar directionsRenderer si está disponible, o crear uno nuevo
  //             if (directionsRenderer) {
  //               directionsRenderer.setDirections(response);
  //             } else {
  //               directionsRenderer = new google.maps.DirectionsRenderer();
  //               directionsRenderer.setDirections(response);
  //             }
  
  //             resolve(response); // Resuelve con la respuesta del servicio de direcciones
  //           } else {
  //             resolve(null); // Resuelve con null si no se obtiene respuesta
  //           }
  //         }
  //       );
  //     })
  //   );
  // }

  // getShortestRoute(routeResponse: google.maps.DirectionsResult) {
  //   console.log('getShortestRoute', routeResponse);
    
  //   let shortestRoute;
  //   routeResponse.routes.forEach(function (route, index) {
  //     if (
  //       !shortestRoute ||
  //       route.legs[0].distance.value < shortestRoute.legs[0].distance.value
  //     )
  //       shortestRoute = route;
  //   });
  //   return shortestRoute;
  // }

  // getFastestRoute(routeResponse: google.maps.DirectionsResult) {
  //   console.log('getFastestRoute' ,routeResponse);
    
  //   let fastestRoute;
  //   routeResponse.routes.forEach(function (route, index) {
  //     if (
  //       !fastestRoute ||
  //       route.legs[0].duration.value < fastestRoute.legs[0].duration.value
  //     )
  //       fastestRoute = route;
  //   });
  //   return fastestRoute;
  // }

  // getSimulateRoute(routeResponse: google.maps.DirectionsResult, distance: number) {
  //   console.log('getSimulateRoute', routeResponse);
  //   let diffDistancia;
  //   let simRoute;
  //   routeResponse.routes.forEach(function (route, index) {
  //     if (!simRoute || Math.abs(route.legs[0].distance.value - (distance * 1000)) < diffDistancia){
  //       simRoute = route;
  //       diffDistancia = Math.abs(route.legs[0].distance.value - (distance * 1000));
  //     }
  //   });
  //   return simRoute;
  // }

  // /**
  //  * returns an interface with the route info
  //  * Calculates and displays a route using a given directions renderer instance.
  //  * Works with multiple destinations and options like 'Avoid tolls/highways'
  //  * @param directionsRenderer  directions renderer instance
  //  * @param origin              origin LatLng of the route
  //  * @param destination         destination LatLng of the route
  //  * @param waypoints           waypoints of the route (optionals)
  //  * @param options             options for the route
  //  */
  // route(
  //   directionsRenderer: google.maps.DirectionsRenderer,
  //   origin: google.maps.LatLng,
  //   destination: google.maps.LatLng,
  //   waypoints?: google.maps.DirectionsWaypoint[],
  //   options?: any
  // ): Observable<IRouteResponse> {
  //   return from(
  //     new Promise<IRouteResponse>((resolve, reject) => {
  //       let directionsService = new google.maps.DirectionsService();
  //       directionsService.route(
  //         {
  //           origin: origin,
  //           waypoints: waypoints,
  //           destination: destination,
  //           travelMode: google.maps.TravelMode.DRIVING,
  //           avoidTolls: options != null ? options.avoidTolls : null,
  //           avoidHighways: options != null ? options.avoidHighways : null,
  //         },
  //         (response, status) => {
  //           if (status === google.maps.DirectionsStatus.OK && response) {
  //             directionsRenderer.setDirections(response);
  //             const routeResponse: IRouteResponse = {
  //               totalDistance: response.routes[0].legs
  //                 .map((x) => x.distance.value)
  //                 .reduce((a, b) => a + b),
  //             };
  //             resolve(routeResponse);
  //           } else {
  //             reject(new Error('Error al definir la ruta con el servicio de Google'));
  //           }
  //         }
  //       );
  //     })
  //   );
  // }

  // public drawCircle(
  //   radius: number,
  //   location: google.maps.LatLng,
  //   map: any
  // ): google.maps.Circle {
  //   return new google.maps.Circle({
  //     strokeColor: 'rgba(45,56,255,0.76)',
  //     strokeOpacity: 0.8,
  //     strokeWeight: 2,
  //     fillColor: 'rgba(132,137,255,0.67)',
  //     fillOpacity: 0.35,
  //     map: map,
  //     center: location,
  //     radius: radius * 1000,
  //   });
  // }

  // /**
  //  * Gets a Google Maps JS instance centered on a position
  //  * @param mapId   ID of the map in the HTML template
  //  * @param center  center of the map
  //  */
  // public getMapOnCurrentPosition(
  //   mapId: string,
  //   center: google.maps.LatLng
  // ): google.maps.Map {
  //   return new google.maps.Map(document.getElementById(mapId), {
  //     zoom: 14,
  //     center: center,
  //     streetViewControl: false,
  //     zoomControl: true,
  //     mapTypeId: google.maps.MapTypeId.ROADMAP,
  //     mapTypeControl: false,
  //   });
  // }

  // /**
  //  * Gets the current position using the browser navigator. If not found, returns the white house
  //  */
  // public getCurrentPosition(): Observable<google.maps.LatLng> {
  //   if ('geolocation' in navigator) {
  //     return Observable.create((observer) => {
  //       if (window.navigator && window.navigator.geolocation) {
  //         window.navigator.geolocation.getCurrentPosition(
  //           (position) => {
  //             observer.next(
  //               new google.maps.LatLng(
  //                 position.coords.latitude,
  //                 position.coords.longitude
  //               )
  //             );
  //             observer.complete();
  //           },
  //           (error) => observer.error(error)
  //         );
  //       } else {
  //         observer.error('Unsupported Browser');
  //       }
  //     });
  //   } else {
  //     return of(new google.maps.LatLng(38.891922, -77.0395067));
  //   }
  // }

  // /**
  //  * Gets the current country code given a location
  //  * @param location  location to get the country code from
  //  */
  // public getCurrentCountry(location: google.maps.LatLng) {
  //   let wc = require('which-country');
  //   return wc([location.lng(), location.lat()]);
  // }

  // /**
  //  * Destroys a map instance and it's listeners given an instance, it's id, and window variable. DirectionsRenderer is optional
  //  * in cases the map needs it to draw a route
  //  * @param map                 instance of the map
  //  * @param mapId               id of the map in the HTML template
  //  * @param window              window var
  //  * @param directionsRenderer  directionsRenderer (optional)
  //  */
  // public destroyMap(
  //   map: google.maps.Map,
  //   mapId: string,
  //   window: any,
  //   directionsRenderer?: google.maps.DirectionsRenderer
  // ) {
  //   const div = document.getElementById(mapId);
  //   google.maps.event.clearInstanceListeners(map);
  //   google.maps.event.clearInstanceListeners(window);
  //   google.maps.event.clearInstanceListeners(document);
  //   google.maps.event.clearInstanceListeners(div);
  //   window.eventListeners().forEach((e) => {
  //     window.removeEventListener('scroll', e);
  //   });
  //   map = null;
  //   if (directionsRenderer) {
  //     directionsRenderer.setMap(null);
  //   }
  // }
}
